/* import __COLOCATED_TEMPLATE__ from './tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    title?: string;
    breadcrumb?: string;
    description?: string | null;
    metricValues: { label: string; value: number | string }[];
    metricColorClass?: string;
    onViewConversations?: () => void;
    showUpgradeButton?: boolean;
    onUpgradeClick?: () => void;
  };
  Blocks: {
    title?: any;
    description?: any;
  };
}

const ConversationFunnelTooltip = templateOnlyComponent<Signature>();
export default ConversationFunnelTooltip;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Bespoke::FinPerformance::ConversationFunnel::Tooltip': typeof ConversationFunnelTooltip;
  }
}
